var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "pa-0 wizard-najomca" },
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { autocomplete: "off" },
              on: { input: _vm.updateFormValid }
            },
            [
              _vm.debug
                ? _c("debug-control", {
                    attrs: {
                      value: [
                        "validationObjectResult",
                        "formValid",
                        "somethingGetDirty",
                        "somethingIsLoading",
                        "currentControl",
                        "zastupca",
                        "pripad"
                      ],
                      parent: this
                    },
                    on: { click: _vm.log }
                  })
                : _vm._e(),
              _c("uvod-banner", {
                class: { "pb-7 mt-45px": !_vm.isMobile },
                attrs: { isMobile: _vm.isMobile }
              }),
              _c(
                "v-card",
                { staticClass: "card" },
                [
                  _c("h2", { staticClass: "mb-6" }, [_vm._v("Nájomca")]),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { xl: "12", lg: "12", md: "12" } },
                        [
                          _c("uvod-forma", {
                            ref: "formaPodn",
                            attrs: {
                              parentReloaded: _vm.reloaded,
                              disabled:
                                _vm.vytvaranieZakaznikaPrebieha ||
                                _vm.zastupca.opUploaded ||
                                _vm.idVytazenia != null
                            },
                            on: { valueChanged: _vm.OnFormaPodnValueChanged },
                            model: {
                              value: _vm.formaPodn,
                              callback: function($$v) {
                                _vm.formaPodn = $$v
                              },
                              expression: "formaPodn"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.formaPodn === 2
                    ? _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("check-box", {
                                key: _vm.formaPodn,
                                ref: "podnikaNaRc",
                                attrs: {
                                  dataId:
                                    "liw_filip__wiz_najomca__btn_podnika_na_rc",
                                  isEnabled:
                                    !_vm.vytvaranieZakaznikaPrebieha &&
                                    !_vm.zastupca.opUploaded &&
                                    _vm.idVytazenia == null
                                },
                                on: {
                                  valueChanged: _vm.OnPodnikaNaRcValueChanged
                                },
                                model: {
                                  value: _vm.podnikaNaRc,
                                  callback: function($$v) {
                                    _vm.podnikaNaRc = $$v
                                  },
                                  expression: "podnikaNaRc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formaPodn === 1 ||
                  (_vm.formaPodn === 2 && !_vm.podnikaNaRc)
                    ? _c(
                        "v-row",
                        {
                          staticClass: "no-padding-top-bottom",
                          class: { "mt-8": _vm.formaPodn != 2 }
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("ico", {
                                ref: "ico",
                                attrs: {
                                  dataId: "liw_filip__wiz_najomca__txt_ico_rc",
                                  formaPodn: _vm.formaPodn,
                                  isEnabled:
                                    _vm.icoEnabled &&
                                    !_vm.zastupca.opUploaded &&
                                    _vm.idVytazenia == null,
                                  placeholder: "Identifikačné číslo nájomcu"
                                },
                                on: {
                                  loading: _vm.vytvaranieZakaznikaPrebieha,
                                  enabledChanged: function(val) {
                                    return (_vm.$refs.obchodMeno.l_isEnabled = val)
                                  },
                                  dataLoaded: _vm.overKlon
                                },
                                model: {
                                  value: _vm.icoObj,
                                  callback: function($$v) {
                                    _vm.icoObj = $$v
                                  },
                                  expression: "icoObj"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("ico", {
                                ref: "obchodMeno",
                                attrs: {
                                  placeholder: "Obchodné meno nájomcu",
                                  dataId:
                                    "liw_filip__wiz_najomca__txt_obch_meno",
                                  obchodneMeno: "",
                                  "ignore-init": "",
                                  formaPodn: _vm.formaPodn,
                                  isEnabled:
                                    _vm.icoEnabled &&
                                    !_vm.zastupca.opUploaded &&
                                    _vm.idVytazenia == null,
                                  loading: _vm.vytvaranieZakaznikaPrebieha
                                },
                                model: {
                                  value: _vm.icoObj,
                                  callback: function($$v) {
                                    _vm.icoObj = $$v
                                  },
                                  expression: "icoObj"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-row",
                        {
                          staticClass: "no-padding-top-bottom",
                          class: { "mt-8": _vm.formaPodn === 3 }
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("text-box", {
                                ref: "meno",
                                attrs: {
                                  parentReloaded: _vm.reloaded,
                                  disabled:
                                    _vm.zastupca.opUploaded ||
                                    _vm.idVytazenia != null,
                                  required: "",
                                  dataId: "liw_filip__wiz_najomca__txt_meno",
                                  placeholder: "Meno nájomcu"
                                },
                                on: {
                                  valueChanged: function($event) {
                                    return _vm.OnMenoValueChanged()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("text-box", {
                                ref: "priezvisko",
                                attrs: {
                                  disabled:
                                    _vm.zastupca.opUploaded ||
                                    _vm.idVytazenia != null,
                                  parentReloaded: _vm.reloaded,
                                  dataId:
                                    "liw_filip__wiz_najomca__txt_priezvisko",
                                  required: "",
                                  placeholder: "Priezvisko nájomcu"
                                },
                                on: {
                                  valueChanged: function($event) {
                                    return _vm.OnPriezviskoValueChanged()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _c(
                    "v-row",
                    { staticClass: "no-padding-top-bottom" },
                    [
                      _c(
                        "v-col",
                        { attrs: { xl: "4", lg: "4", md: "4" } },
                        [
                          _c("text-box", {
                            ref: "email",
                            attrs: {
                              parentReloaded: _vm.reloaded,
                              dataId: "liw_filip__wiz_najomca__txt_email",
                              placeholder: "@",
                              required: "",
                              email: "",
                              disabled: _vm.idVytazenia != null
                            },
                            on: {
                              input: function(val) {
                                return (_vm.email = val)
                              },
                              valueChanged: function($event) {
                                return _vm.OnEmailValueChanged()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { xl: "4", lg: "4", md: "4" } },
                        [
                          _c("text-box", {
                            ref: "telCislo",
                            attrs: {
                              parentReloaded: _vm.reloaded,
                              dataId: "liw_filip__wiz_najomca__txt_telefon",
                              rules: [_vm.telefonneCisloRule],
                              placeholder: "+421",
                              required: "",
                              textOnFocus: "+421",
                              removeCharacters: /[^+\d]/g,
                              isPhoneNumber: true,
                              disabled: _vm.idVytazenia != null
                            },
                            on: {
                              input: function(val) {
                                return (_vm.telefon = val)
                              },
                              valueChanged: function($event) {
                                return _vm.getOPBtn()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "no-padding-top-bottom" },
                    [
                      _c(
                        "v-col",
                        { attrs: { xl: "4", lg: "4", md: "4" } },
                        [
                          _c("dynamic-combo", {
                            attrs: {
                              label: "Zdroj ponuky",
                              parentReloaded: _vm.reloaded,
                              dataId: "liw_filip__wiz_najomca__cb_zdroj_ponuky",
                              disabled: _vm.idVytazenia != null
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card",
                { staticClass: "mt-6 card" },
                [
                  _c("h2", { class: { "mb-4": _vm.formaPodn === 3 } }, [
                    _vm._v("Kontaktná osoba")
                  ]),
                  _c(
                    "v-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formaPodn == 1,
                          expression: "formaPodn == 1"
                        }
                      ]
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { xl: "4", lg: "4", md: "4" } },
                        [
                          _c("dynamic-combo", {
                            ref: "idStatutar",
                            staticClass: "mt-6",
                            attrs: {
                              label: "Štatutár",
                              dataId:
                                "liw_filip__wiz_kontaktna_osoba__cb_statutari",
                              idZastupcu: _vm.pripad.idZastupcu,
                              disabled: _vm.idVytazenia != null
                            },
                            on: {
                              input: function(v) {
                                return (_vm.idStatutar = v)
                              },
                              valueChanged: function() {
                                return this$1.loadStatutar()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { xl: "4", lg: "4", md: "4" } },
                        [
                          _c("dynamic-combo", {
                            ref: "idFunkcie",
                            staticClass: "mt-6",
                            attrs: {
                              label: "Funkcia",
                              dataId:
                                "liw_filip__wiz_kontaktna_osoba__cb_funkcie",
                              idZastupcu: _vm.pripad.idZastupcu,
                              disabled: _vm.idVytazenia != null
                            },
                            on: {
                              input: function(v) {
                                return (_vm.idFunkcie = v)
                              },
                              valueChanged: function() {
                                return this$1.$refs.idFunkcie.loadData()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _vm.formaPodn == 1 || _vm.formaPodn == 2
                        ? _c(
                            "v-col",
                            {
                              staticStyle: { height: "70px" },
                              attrs: { xl: "3", lg: "3", md: "3" }
                            },
                            [
                              _c("check-box", {
                                ref: "kuv",
                                attrs: {
                                  label: "Konečný užívateľ výhod",
                                  dataId:
                                    "liw_filip__wiz_kontaktna_osoba__btn_kuv",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  disabled: _vm.idVytazenia != null
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formaPodn == 1 || _vm.formaPodn == 2
                        ? _c(
                            "v-col",
                            { attrs: { xl: "3", lg: "3", md: "3" } },
                            [
                              _c("check-box", {
                                ref: "jeKonatel",
                                attrs: {
                                  label: "Štatutárny zástupca",
                                  dataId:
                                    "liw_filip__wiz_kontaktna_osoba__btn_je_konatel",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  disabled: _vm.idVytazenia != null
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        { attrs: { xl: "3", lg: "3", md: "3" } },
                        [
                          _c("check-box", {
                            ref: "zahrOsoba",
                            attrs: {
                              label: "Zahraničná osoba",
                              dataId:
                                "liw_filip__wiz_kontaktna_osoba__btn_zahr_osoba",
                              idZastupcu: _vm.pripad.idZastupcu,
                              parentReloaded: _vm.reloaded,
                              disabled: _vm.idVytazenia != null
                            },
                            on: {
                              input: function(v) {
                                return (_vm.zastupca.zahranicnaOsoba = v)
                              },
                              valueChanged: function() {
                                if (this$1.$refs.rodnePriezvisko) {
                                  this$1.$refs.rodnePriezvisko.loadData()
                                }
                                this$1.$refs.obcianstvo.loadData()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { xl: "3", lg: "3", md: "3" } },
                        [
                          _c("check-box", {
                            ref: "profilPartneraVKZ",
                            attrs: {
                              label: "Profil partnera v KZ",
                              dataId:
                                "liw_filip__wiz_kontaktna_osoba__btn_ma_profil_kz",
                              idZastupcu: _vm.pripad.idZastupcu,
                              disabled: _vm.idVytazenia != null
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mb-8" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "col-auto" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-primary",
                              attrs: {
                                disabled:
                                  _vm.sendingRequest || _vm.idVytazenia != null
                              },
                              on: {
                                click: function($event) {
                                  return _vm.sendIdentityTB()
                                }
                              }
                            },
                            [_vm._v(" Odoslať Identity TB ")]
                          ),
                          _vm.nahratOpBtn.visible
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-primary ml-5",
                                  attrs: {
                                    disabled:
                                      _vm.nahratOpBtn.disabled ||
                                      _vm.sendingRequest ||
                                      _vm.idVytazenia != null
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.confirmAndSendOp()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " Nahrať " +
                                      _vm._s(
                                        _vm.zastupca.zahranicnaOsoba
                                          ? "doklad"
                                          : "OP"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.odfotitOpBtn.visible,
                                  expression: "odfotitOpBtn.visible"
                                }
                              ],
                              staticClass: "btn-primary ml-5",
                              attrs: {
                                disabled:
                                  _vm.odfotitOpBtn.disabled ||
                                  _vm.sendingRequest ||
                                  _vm.idVytazenia != null
                              },
                              on: {
                                click: function($event) {
                                  return _vm.confirmAndOpenSendOpMobilDialog()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " Odfotiť " +
                                  _vm._s(
                                    _vm.zastupca.zahranicnaOsoba
                                      ? "doklad"
                                      : "OP"
                                  ) +
                                  " cez MT "
                              )
                            ]
                          ),
                          _c(
                            "v-dialog",
                            {
                              attrs: {
                                "overlay-color": "#000",
                                "overlay-opacity": "0.66",
                                persistent: "",
                                "max-width": "500"
                              },
                              model: {
                                value: _vm.dialog,
                                callback: function($$v) {
                                  _vm.dialog = $$v
                                },
                                expression: "dialog"
                              }
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between"
                                    },
                                    [
                                      _vm._v(
                                        " Zadajte tel. číslo pre nahratie " +
                                          _vm._s(
                                            _vm.zastupca.zahranicnaOsoba
                                              ? "dokladu"
                                              : "občianského preukazu"
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.dialog = false
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("mdi-close")])],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("text-box", {
                                        ref: "opTelCislo",
                                        attrs: {
                                          rules: [_vm.telefonneCisloRule],
                                          label: "Zadajte tel. číslo",
                                          placeholder: "+421",
                                          required: "",
                                          textOnFocus: "+421",
                                          removeCharacters: /[^+\d]/g,
                                          isPhoneNumber: true,
                                          cache: false
                                        },
                                        on: {
                                          input: function(val) {
                                            return (_vm.opTelefon = val)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-secondary ml-5",
                                          on: {
                                            click: function($event) {
                                              _vm.dialog = false
                                            }
                                          }
                                        },
                                        [_vm._v(" Späť ")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-primary",
                                          on: {
                                            click: function($event) {
                                              return _vm.sendOpMobil()
                                            }
                                          }
                                        },
                                        [_vm._v(" Odoslať ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-secondary ml-5",
                              attrs: { disabled: _vm.idVytazenia != null },
                              on: {
                                click: function($event) {
                                  _vm.zadatOpManualne = !_vm.zadatOpManualne
                                }
                              }
                            },
                            [
                              _vm._v(
                                " Zadať " +
                                  _vm._s(
                                    _vm.zastupca.zahranicnaOsoba
                                      ? "doklad"
                                      : "OP"
                                  ) +
                                  " manuálne "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "col-auto" },
                        [
                          _c("check-box", {
                            ref: "fyzickeOverenie",
                            staticStyle: { "margin-top": "-12px" },
                            attrs: {
                              label: "Fyzické overenie",
                              dataId:
                                "liw_filip__wiz_kontaktna_osoba__btn_fyzicke_overenie",
                              idZastupcu: _vm.pripad.idZastupcu,
                              disabled: _vm.idVytazenia != null
                            },
                            on: {
                              input: function(v) {
                                return (_vm.fyzickeOverenie = v)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zadatOpManualne,
                          expression: "zadatOpManualne"
                        }
                      ]
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mt-8" },
                        [
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("dynamic-combo", {
                                ref: "titul",
                                attrs: {
                                  label: "Titul",
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__cb_tituly",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  parentReloaded: _vm.reloaded,
                                  disabled: _vm.idVytazenia != null
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("dynamic-combo", {
                                ref: "pohlavie",
                                attrs: {
                                  label: "Pohlavie",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__cb_pohlavia",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  input: function(val) {
                                    return (_vm.zastupca.pohlavie = val)
                                  },
                                  valueChanged: function() {
                                    return this$1.$refs.pohlavieCard.loadData()
                                  },
                                  dataLoaded: function() {
                                    return this$1.$refs.pohlavieCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("text-box", {
                                ref: "zastupcaMeno",
                                attrs: {
                                  label: "Meno",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_meno",
                                  placeholder: "Meno kontaktnej osoby",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function() {
                                    return this$1.$refs.zastupcaMenoCard.loadData()
                                  },
                                  input: function(v) {
                                    return (this$1.zastupcaMeno = v)
                                  },
                                  dataLoaded: function() {
                                    return this$1.$refs.zastupcaMenoCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("text-box", {
                                ref: "zastupcaPriezvisko",
                                attrs: {
                                  label: "Priezvisko",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  placeholder: "Priezvisko kontaktnej osoby",
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_priezvisko",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function() {
                                    this$1.$refs.zastupcaPriezviskoCard.loadData()
                                    if (this$1.$refs.rodnePriezvisko) {
                                      this$1.$refs.rodnePriezvisko.loadData()
                                    }
                                  },
                                  input: function(v) {
                                    return (this$1.zastupcaPriezvisko = v)
                                  },
                                  dataLoaded: function() {
                                    this$1.$refs.zastupcaPriezviskoCard.loadData()
                                    if (this$1.$refs.rodnePriezvisko) {
                                      this$1.$refs.rodnePriezvisko.loadData()
                                    }
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("DatePicker", {
                                ref: "datumNarodenia",
                                attrs: {
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  label: "Dátum narodenia",
                                  placeholder: "DD/MM/YYYY",
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_datum_narodenia",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function() {
                                    return this$1.$refs.datumNarodeniaCard.loadData()
                                  },
                                  dataLoaded: function() {
                                    return this$1.$refs.datumNarodeniaCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("dynamic-combo", {
                                ref: "obcianstvo",
                                attrs: {
                                  label: "Štátne občianstvo",
                                  staticLabel: _vm.zastupca.zahranicnaOsoba
                                    ? "Štátna príslušnosť"
                                    : "Štátne občianstvo",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  parentReloaded: _vm.reloaded,
                                  rules: [
                                    function(v) {
                                      return _vm.statnaPrislusnostRule(v)
                                    }
                                  ],
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__cb_statne_obcianstvo",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function() {
                                    return this$1.$refs.obcianstvoCard.loadData()
                                  },
                                  dataLoaded: function() {
                                    return this$1.$refs.obcianstvoCard.loadData()
                                  },
                                  input: function(val) {
                                    return (_vm.zastupca.obcianstvo = val)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("text-box", {
                                ref: "rodneCislo",
                                attrs: {
                                  rodneCislo: !_vm.zastupca.zahranicnaOsoba,
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  label: "Rodné číslo",
                                  staticLabel: _vm.zastupca.zahranicnaOsoba
                                    ? "Identifikačné číslo"
                                    : "Rodné číslo",
                                  placeholder: _vm.zastupca.zahranicnaOsoba
                                    ? "idč. bez /"
                                    : "rdč. bez /",
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_rc",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function() {
                                    this$1.$refs.rodneCisloCard.loadData()
                                    this$1.OnRodneCisloValueChanged()
                                    this$1.$refs.fyzickeOverenie.loadData()
                                  },
                                  input: function(val) {
                                    return (_vm.zastupca.rodneCislo = val)
                                  },
                                  dataLoaded: function() {
                                    return this$1.$refs.rodneCisloCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("text-box", {
                                ref: "cisloOp",
                                attrs: {
                                  label: "Číslo OP",
                                  staticLabel: _vm.zastupca.zahranicnaOsoba
                                    ? "Číslo dokladu"
                                    : "Číslo OP",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  placeholder: "XX123456",
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_cislo_op",
                                  parentReloaded: _vm.reloaded,
                                  maxValue: 14,
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function() {
                                    return this$1.$refs.cisloOpCard.loadData()
                                  },
                                  dataLoaded: function() {
                                    return this$1.$refs.cisloOpCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("DatePicker", {
                                ref: "datumVydania",
                                attrs: {
                                  staticLabel: _vm.zastupca.zahranicnaOsoba
                                    ? "Platnosť od"
                                    : "Dátum vydania",
                                  placeholder: "DD/MM/YYYY",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_datum_vydania_op",
                                  parentReloaded: _vm.reloaded,
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function(val) {
                                    this$1.$refs.datumVydaniaCard.loadData()
                                    this$1.setDatumPlatnostiPlus10(val)
                                  },
                                  dataLoaded: function() {
                                    return this$1.$refs.datumVydaniaCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("DatePicker", {
                                ref: "datumPlatnosti",
                                attrs: {
                                  label: "Dátum platnosti",
                                  staticLabel: _vm.zastupca.zahranicnaOsoba
                                    ? "Platnosť do"
                                    : "Dátum platnosti",
                                  placeholder: "DD/MM/YYYY",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_datum_platnosti_op",
                                  parentReloaded: _vm.reloaded,
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function() {
                                    return this$1.$refs.datumPlatnostiCard.loadData()
                                  },
                                  dataLoaded: function() {
                                    return this$1.$refs.datumPlatnostiCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("combo-box", {
                                ref: "mesto",
                                class: { readonly: _vm.zastupca.readonly },
                                attrs: {
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_mesto",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  parentReloaded: _vm.reloaded,
                                  label: "Mesto/obec",
                                  items: _vm.mestoSearchData,
                                  loading: _vm.mestoSearchLoading.value,
                                  clearable: "",
                                  naked: "",
                                  outerSearch: true,
                                  returnObject: "",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  valueChanged: function() {
                                    this$1.$refs.mestoCard.loadData()
                                    _vm.cityOnChange()
                                  },
                                  input: function(val) {
                                    return (_vm.mesto = val)
                                  },
                                  search: function(val) {
                                    _vm.searchCity(val, 3)
                                  },
                                  dataLoaded: function(val) {
                                    _vm.mesto = val
                                    _vm
                                      .searchCity(val, 3, 0, true)
                                      .then(function() {
                                        return _vm.$refs.ulica.loadData()
                                      })
                                    this$1.$refs.mestoCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("combo-box", {
                                ref: "ulica",
                                class: { readonly: _vm.zastupca.readonly },
                                attrs: {
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_ulica_cislo",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  parentReloaded: _vm.reloaded,
                                  label: "Ulica",
                                  items: _vm.ulicaSearchData,
                                  loading: _vm.ulicaSearchLoading.value,
                                  clearable: "",
                                  naked: "",
                                  outerSearch: true,
                                  returnObject: "",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  input: function(val) {
                                    return (_vm.ulica = val)
                                  },
                                  dataLoaded: function(val) {
                                    _vm.ulica = val
                                    _vm
                                      .searchStreets(val, 3, 0, true)
                                      .then(function() {
                                        return _vm.$refs.cisloDomu.loadData()
                                      })
                                    this$1.$refs.ulicaCard.loadData()
                                  },
                                  search: function(val) {
                                    _vm.searchStreets(val, 3)
                                  },
                                  valueChanged: function() {
                                    this$1.$refs.ulicaCard.loadData()
                                    _vm.streetOnChange()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("combo-box", {
                                ref: "cisloDomu",
                                class: { readonly: _vm.zastupca.readonly },
                                attrs: {
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_cislo_domu",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  parentReloaded: _vm.reloaded,
                                  label: "Číslo domu",
                                  items: _vm.cislo_domuSearchData,
                                  loading: _vm.cislo_domuSearchLoading.value,
                                  clearable: "",
                                  naked: "",
                                  outerSearch: true,
                                  returnObject: "",
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  input: function(val) {
                                    return (_vm.cislo_domu = val)
                                  },
                                  dataLoaded: function(val) {
                                    _vm.cislo_domu = val
                                    _vm
                                      .searchAddresses(val, 0, 0, true)
                                      .then(function() {
                                        return _vm.$refs.psc.loadData()
                                      })
                                      .then(function() {
                                        return (_vm.adresyInitialized = true)
                                      })
                                    _vm.$refs.cisloDomuCard.loadData()
                                  },
                                  search: function(val) {
                                    _vm.searchAddresses(val, 0)
                                  },
                                  valueChanged: function() {
                                    _vm.$refs.cisloDomuCard.loadData()
                                    _vm.addressOnChange()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { xl: "4", lg: "4", md: "4" } },
                            [
                              _c("combo-box", {
                                ref: "psc",
                                class: { readonly: _vm.zastupca.readonly },
                                attrs: {
                                  "data-id":
                                    "liw_filip__wiz_kontaktna_osoba__txt_psc",
                                  idZastupcu: _vm.pripad.idZastupcu,
                                  parentReloaded: _vm.reloaded,
                                  label: "PSČ",
                                  items: _vm.pscSearchData,
                                  loading: _vm.pscSearchLoading.value,
                                  clearable: "",
                                  naked: "",
                                  outerSearch: true,
                                  returnObject: "",
                                  rules: [_vm.pscRule],
                                  disabled: _vm.idVytazenia != null
                                },
                                on: {
                                  input: function(val) {
                                    return (_vm.psc = val)
                                  },
                                  dataLoaded: function(val) {
                                    _vm.psc = val
                                    _vm.searchZIP(val, 0, 0, true)
                                    _vm.$refs.pscCard.loadData()
                                  },
                                  search: function(val) {
                                    _vm.searchZIP(val, 0)
                                  },
                                  valueChanged: function() {
                                    _vm.$refs.pscCard.loadData()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.zadatOpManualne,
                          expression: "!zadatOpManualne"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex op-cards" },
                        [
                          _c(
                            "v-card",
                            { staticClass: "op-back pb-0" },
                            [
                              _c(
                                "v-row",
                                [
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          readonly: _vm.zastupca.readonly
                                        }
                                      },
                                      [
                                        _c("combo-box", {
                                          ref: "mestoCard",
                                          class: {
                                            readonly: _vm.zastupca.readonly
                                          },
                                          attrs: {
                                            "data-id":
                                              "liw_filip__wiz_kontaktna_osoba__txt_mesto",
                                            idZastupcu: _vm.pripad.idZastupcu,
                                            parentReloaded: _vm.reloaded,
                                            label: "Mesto/obec",
                                            items: _vm.mestoSearchData,
                                            readonly: _vm.zastupca.readonly,
                                            loading:
                                              _vm.mestoSearchLoading.value,
                                            clearable: "",
                                            naked: "",
                                            outerSearch: true,
                                            returnObject: "",
                                            disabled: _vm.idVytazenia != null
                                          },
                                          on: {
                                            input: function(val) {
                                              return (_vm.mesto = val)
                                            },
                                            search: function(val) {
                                              _vm.searchCity(val, 3)
                                            },
                                            valueChanged: function() {
                                              this$1.$refs.mesto.loadData()
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("v-col", { attrs: { cols: "6" } }),
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          readonly: _vm.zastupca.readonly
                                        }
                                      },
                                      [
                                        _c("combo-box", {
                                          ref: "ulicaCard",
                                          class: {
                                            readonly: _vm.zastupca.readonly
                                          },
                                          attrs: {
                                            "data-id":
                                              "liw_filip__wiz_kontaktna_osoba__txt_ulica_cislo",
                                            idZastupcu: _vm.pripad.idZastupcu,
                                            parentReloaded: _vm.reloaded,
                                            label: "Ulica",
                                            items: _vm.ulicaSearchData,
                                            readonly: _vm.zastupca.readonly,
                                            loading:
                                              _vm.ulicaSearchLoading.value,
                                            clearable: "",
                                            naked: "",
                                            outerSearch: true,
                                            returnObject: "",
                                            disabled: _vm.idVytazenia != null
                                          },
                                          on: {
                                            input: function(val) {
                                              return (_vm.ulica = val)
                                            },
                                            search: function(val) {
                                              _vm.searchStreets(val, 3)
                                            },
                                            valueChanged: function() {
                                              this$1.$refs.ulica.loadData()
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          readonly: _vm.zastupca.readonly
                                        }
                                      },
                                      [
                                        _c("combo-box", {
                                          ref: "cisloDomuCard",
                                          class: {
                                            readonly: _vm.zastupca.readonly
                                          },
                                          attrs: {
                                            "data-id":
                                              "liw_filip__wiz_kontaktna_osoba__txt_cislo_domu",
                                            idZastupcu: _vm.pripad.idZastupcu,
                                            parentReloaded: _vm.reloaded,
                                            label: "Číslo domu",
                                            items: _vm.cislo_domuSearchData,
                                            readonly: _vm.zastupca.readonly,
                                            loading:
                                              _vm.cislo_domuSearchLoading.value,
                                            clearable: "",
                                            naked: "",
                                            outerSearch: true,
                                            returnObject: "",
                                            disabled: _vm.idVytazenia != null
                                          },
                                          on: {
                                            input: function(val) {
                                              return (_vm.cislo_domu = val)
                                            },
                                            search: function(val) {
                                              _vm.searchAddresses(val, 0)
                                            },
                                            valueChanged: function() {
                                              _vm.$refs.cisloDomu.loadData()
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          readonly: _vm.zastupca.readonly
                                        }
                                      },
                                      [
                                        _c("combo-box", {
                                          ref: "pscCard",
                                          class: {
                                            readonly: _vm.zastupca.readonly
                                          },
                                          attrs: {
                                            "data-id":
                                              "liw_filip__wiz_kontaktna_osoba__txt_psc",
                                            idZastupcu: _vm.pripad.idZastupcu,
                                            parentReloaded: _vm.reloaded,
                                            label: "PSČ",
                                            items: _vm.pscSearchData,
                                            readonly: _vm.zastupca.readonly,
                                            loading: _vm.pscSearchLoading.value,
                                            clearable: "",
                                            naked: "",
                                            outerSearch: true,
                                            returnObject: "",
                                            rules: [_vm.pscRule],
                                            disabled: _vm.idVytazenia != null
                                          },
                                          on: {
                                            input: function(val) {
                                              return (_vm.psc = val)
                                            },
                                            search: function(val) {
                                              _vm.searchZIP(val, 0)
                                            },
                                            valueChange: function() {
                                              _vm.$refs.psc.loadData()
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("v-col", { attrs: { cols: "6" } }),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c("text-box", {
                                        ref: "miestoNarodenia",
                                        class: {
                                          readonly: _vm.zastupca.readonly
                                        },
                                        attrs: {
                                          dataId:
                                            "liw_filip__wiz_kontaktna_osoba__txt_miesto_narodenia",
                                          idZastupcu: _vm.pripad.idZastupcu,
                                          parentReloaded: _vm.reloaded,
                                          label: "Miesto narodenia",
                                          readonly: _vm.zastupca.readonly,
                                          naked: "",
                                          disabled: _vm.idVytazenia != null
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      !_vm.zastupca.zahranicnaOsoba
                                        ? _c("text-box", {
                                            ref: "rodnePriezvisko",
                                            class: {
                                              readonly: _vm.zastupca.readonly
                                            },
                                            attrs: {
                                              dataId:
                                                "liw_filip__wiz_kontaktna_osoba__txt_rodne_priezvisko",
                                              label: "Rodné priezvisko",
                                              idZastupcu: _vm.pripad.idZastupcu,
                                              readonly: _vm.zastupca.readonly,
                                              naked: "",
                                              disabled: _vm.idVytazenia != null
                                            }
                                          })
                                        : _c("text-box", {
                                            key: _vm.zastupca.zahranicnaOsoba,
                                            staticClass: "readonly",
                                            attrs: {
                                              naked: "",
                                              readonly: "",
                                              disabled: _vm.idVytazenia != null
                                            }
                                          })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c("text-box", {
                                        ref: "osobitneZaznamy",
                                        class: {
                                          readonly: _vm.zastupca.readonly
                                        },
                                        attrs: {
                                          dataId:
                                            "liw_filip__wiz_kontaktna_osoba__txt_osobitne_zaznamy",
                                          idZastupcu: _vm.pripad.idZastupcu,
                                          parentReloaded: _vm.reloaded,
                                          label: "Osobité záznamy",
                                          readonly: _vm.zastupca.readonly,
                                          naked: "",
                                          disabled: _vm.idVytazenia != null
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    top: "",
                                    "close-delay": 0,
                                    "open-delay": 200
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "btn-icon btn-op-edit",
                                                class: {
                                                  "btn-terciary":
                                                    _vm.zastupca.readonly,
                                                  "btn-secondary": !_vm.zastupca
                                                    .readonly
                                                },
                                                attrs: {
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editOp(
                                                      _vm.zastupca
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.zastupca.readonly
                                                        ? "mdi-pencil-outline"
                                                        : "mdi-check"
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.zastupca.readonly
                                          ? "Editovať"
                                          : "Potvrdiť"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-card",
                            { staticClass: "op order-first pb-0 px-25px" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _c("v-img", {
                                    staticClass: "mt-30px",
                                    attrs: {
                                      width: 123,
                                      height: 163,
                                      src: _vm.opImage
                                    }
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "pl-34px" },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "7" } },
                                            [
                                              _c("text-box", {
                                                ref: "zastupcaPriezviskoCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  "data-id":
                                                    "liw_filip__wiz_kontaktna_osoba__txt_priezvisko",
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  naked: "",
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  input: function(v) {
                                                    return (this$1.zastupcaPriezvisko = v)
                                                  },
                                                  valueChanged: function() {
                                                    return this$1.$refs.zastupcaPriezvisko.loadData()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "5" } },
                                            [
                                              _c("date-picker", {
                                                ref: "datumNarodeniaCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  dataId:
                                                    "liw_filip__wiz_kontaktna_osoba__txt_datum_narodenia",
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  "no-icon": "",
                                                  "text-only": "",
                                                  naked: "",
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  valueChanged: function() {
                                                    return this$1.$refs.datumNarodenia.loadData()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "7" } },
                                            [
                                              _c("text-box", {
                                                ref: "zastupcaMenoCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  dataId:
                                                    "liw_filip__wiz_kontaktna_osoba__txt_meno",
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  naked: "",
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  input: function(v) {
                                                    return (this$1.zastupcaMeno = v)
                                                  },
                                                  valueChanged: function() {
                                                    return this$1.$refs.zastupcaMeno.loadData()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "5" } },
                                            [
                                              _c("text-box", {
                                                ref: "rodneCisloCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  "data-id":
                                                    "liw_filip__wiz_kontaktna_osoba__txt_rc",
                                                  staticLabel: _vm.zastupca
                                                    .zahranicnaOsoba
                                                    ? "Identifikačné číslo"
                                                    : "Rodné číslo",
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  rodneCislo: !_vm.zastupca
                                                    .zahranicnaOsoba,
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  naked: "",
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  input: function(val) {
                                                    return (_vm.zastupca.rodneCislo = val)
                                                  },
                                                  valueChanged: function() {
                                                    this$1.$refs.rodneCislo.loadData()
                                                    this$1.OnRodneCisloValueChanged()
                                                    this$1.$refs.fyzickeOverenie.loadData()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "pr-0",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c("dynamic-combo", {
                                                ref: "obcianstvoCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  "data-id":
                                                    "liw_filip__wiz_kontaktna_osoba__cb_statne_obcianstvo",
                                                  staticLabel: _vm.zastupca
                                                    .zahranicnaOsoba
                                                    ? "Štátna príslušnosť"
                                                    : "Štátne občianstvo",
                                                  rules: [
                                                    function(v) {
                                                      return _vm.statnaPrislusnostRule(
                                                        v
                                                      )
                                                    }
                                                  ],
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  parentReloaded: _vm.reloaded,
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  naked: "",
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  input: function(val) {
                                                    return (_vm.zastupca.obcianstvo = val)
                                                  },
                                                  valueChanged: function() {
                                                    return this$1.$refs.obcianstvo.loadData()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "5" } },
                                            [
                                              _c("dynamic-combo", {
                                                ref: "pohlavieCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  "data-id":
                                                    "liw_filip__wiz_kontaktna_osoba__cb_pohlavia",
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  naked: "",
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  input: function(val) {
                                                    return (_vm.zastupca.pohlavie = val)
                                                  },
                                                  valueChanged: function() {
                                                    return this$1.$refs.pohlavie.loadData()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c("v-col", { attrs: { cols: "2" } }),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "5" } },
                                            [
                                              _c("date-picker", {
                                                ref: "datumPlatnostiCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  dataId:
                                                    "liw_filip__wiz_kontaktna_osoba__txt_datum_platnosti_op",
                                                  staticLabel: _vm.zastupca
                                                    .zahranicnaOsoba
                                                    ? "Platnosť do"
                                                    : "Dátum platnosti",
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  "no-icon": "",
                                                  "text-only": "",
                                                  naked: "",
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  valueChanged: function() {
                                                    return this$1.$refs.datumPlatnosti.loadData()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "5" } },
                                            [
                                              _c("text-box", {
                                                ref: "cisloOpCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  dataId:
                                                    "liw_filip__wiz_kontaktna_osoba__txt_cislo_op",
                                                  staticLabel: _vm.zastupca
                                                    .zahranicnaOsoba
                                                    ? "Číslo dokladu"
                                                    : "Číslo OP",
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  naked: "",
                                                  maxValue: 14,
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  valueChanged: function() {
                                                    return this$1.$refs.cisloOp.loadData()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c("v-col", { attrs: { cols: "2" } }),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "5" } },
                                            [
                                              _c("date-picker", {
                                                ref: "datumVydaniaCard",
                                                class: {
                                                  readonly:
                                                    _vm.zastupca.readonly
                                                },
                                                attrs: {
                                                  dataId:
                                                    "liw_filip__wiz_kontaktna_osoba__txt_datum_vydania_op",
                                                  idZastupcu:
                                                    _vm.pripad.idZastupcu,
                                                  readonly:
                                                    _vm.zastupca.readonly,
                                                  "no-icon": "",
                                                  "text-only": "",
                                                  naked: "",
                                                  disabled:
                                                    _vm.idVytazenia != null
                                                },
                                                on: {
                                                  valueChanged: function(val) {
                                                    this$1.$refs.datumVydania.loadData()
                                                    this$1.setDatumPlatnostiPlus10(
                                                      val
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("message-box", {
            attrs: {
              title: _vm.checkNajomcaMessage.title,
              text: _vm.checkNajomcaMessage.text,
              persistent: "",
              "hide-cancel": ""
            },
            model: {
              value: _vm.checkNajomcaMessage.open,
              callback: function($$v) {
                _vm.$set(_vm.checkNajomcaMessage, "open", $$v)
              },
              expression: "checkNajomcaMessage.open"
            }
          }),
          _c("message-box", {
            attrs: {
              title: _vm.checkOpUploadedMessage.title,
              text: _vm.checkOpUploadedMessage.text,
              action: _vm.checkOpUploadedMessage.action,
              cancel: _vm.checkOpUploadedMessage.cancel,
              persistent: "",
              "yes-no": ""
            },
            model: {
              value: _vm.checkOpUploadedMessage.open,
              callback: function($$v) {
                _vm.$set(_vm.checkOpUploadedMessage, "open", $$v)
              },
              expression: "checkOpUploadedMessage.open"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }